import type { Rolle } from "../../daten/typen";
import { rechteAus } from "../../schale/rechte";

/* ══════════════════════════════════════════════════════════════════
   Wer am Telefon einen Preis sehen darf.

   **Der technische Außendienst sieht keine Preise.** Er fährt hin, bereitet
   vor, übergibt und nimmt zurück (20-prozesse.md, D1) — Marge, offene Posten
   und Kundenkonditionen gehören nicht auf den Schirm, den er im Regen
   aufhat. Dieselbe Linie zieht `Handy.tsx` schon für die Tagesliste.

   **Nachschlagen steht daneben und fällt mit.** „Was ist frei" ist die
   Vorstufe einer Zusage beim Kunden, und Zusagen macht der Vertrieb.

   ── Seit dem 18.09.2026 ist es ein Recht ───────────────────────────

   Bis dahin hieß die Frage „trägt er `technik` und sonst nichts". Das war
   die Rolle als Einheit, und sie konnte zweierlei nicht: einem Techniker
   die Preise geben und einem Außendienstler sie nehmen. Jetzt ist es das
   Recht `preise` (Migration 0147), und beides ist in Einstellungen →
   Benutzer einstellbar.

   Der Riegel bleibt die API (`apps/api/src/mitte/rechte.ts`,
   `preiseVerbergen`): Sie nimmt jedes Geldfeld aus der Antwort heraus. Was
   hier steht, ist Wegweisung — damit der Schirm gar nicht erst erscheint,
   statt leer zu bleiben (28-designkonzept.md: was nicht erlaubt ist,
   erscheint nicht).
   ══════════════════════════════════════════════════════════════════ */

/**
 * Darf dieser Mensch keinen Preis sehen?
 *
 * **Wer gar nichts darf, bekommt hier `false`** — er sieht diese Schirme
 * ohnehin nicht, und ein `true` machte aus „noch keine Rolle" eine Aussage
 * über Preise, die niemand getroffen hat. Dieselbe Linie wie vorher.
 */
export function ohnePreisrecht(rollen: Rolle[] | undefined): boolean {
  const hat = rollen ?? [];
  if (hat.length === 0) return false;
  return !rechteAus(hat).includes("preise");
}
